var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[_c('v-chip',{style:(_vm.styles),attrs:{"color":"#73D995"}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }